import config from "../config";

const _storage = localStorage;
const _session = sessionStorage;

/**
 * Store a value in storage.
 *
 * @param key
 * @param value
 */
export const store = (key, value) => {
    _storage.setItem(key, JSON.stringify(value));
};

/**
 * Save a value in session. NOTE! Will be deleted when window session ends.
 *
 * @param key
 * @param value
 */
export const save = (key, value) => {
    _session.setItem(key, JSON.stringify(value))
};

/**
 * Get value from key in storage.
 */
export const get = (key) => {
    return JSON.parse(_storage.getItem(key) || _session.getItem(key));
};

/**
 * Remove the key from storage.
 *
 * @param key
 */
export const remove = (key) => {
    _storage.removeItem(key) || _session.removeItem(key);
};

/**
 * Clear the storage for this domain.
 */
export const clear = () => {
    // Save the language selection
    const language = _storage.getItem(config.lang.LANGUAGE_IDENTIFIER);
    _storage.clear();
    _session.clear();
    _storage.setItem(config.lang.LANGUAGE_IDENTIFIER, language);
};



// WEBPACK FOOTER //
// ./src/services/StorageService.js